import styled from 'styled-components'

export const IconBackground = styled.div`
  background-color: var(--neutral-theme);
  margin: 0 0 0 0;
`
